/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import GalaxyModel from 'astro/server/session';

import UsersState from 'astro/fake/state/users';
import ConstantsState from 'astro/fake/state/constants';

import PlanetsState from 'astro/fake/state/planets';
import SpaceshipsState from 'astro/fake/state/spaceships';


export default (galaxy) =>
{
  let state = new Immutable.Map();

  state = state.set('currentGalaxy', galaxy.getCurrentGalaxy());

  state = state.set('users', UsersState(galaxy.getUsers()));
  state = state.set('constants', ConstantsState(galaxy.getConstants()));

  state = state.set('planets', PlanetsState(galaxy.getPlanets()));
  state = state.set('spaceships', SpaceshipsState(galaxy.getSpaceships()));

  return new GalaxyModel(state, null);
}
